import {Get} from "../axios.config";

/**
 * @description: 获取登录信息
 */
export function getUserLogin(){
    const url = "/v2/passport/user/me";
    return Get({
        url
    });
}


// WEBPACK FOOTER //
// ./src/api/common/user.js